<ion-card class="activity-statistics">
    <ion-card-header>
        <ion-card-title>{{ 'dashboard.status.activity.title' | translate }}</ion-card-title>
    </ion-card-header>
    <ion-card-content>
        <app-loading-indicator *ngIf="loading">{{ 'dashboard.status.activity.loading' | translate }}</app-loading-indicator>
        <ng-container *ngIf="!loading && offlineError">{{ 'dashboard.status.activity.offline-message' | translate }}</ng-container>
        <ng-container *ngIf="!loading && noDataError">{{ 'dashboard.status.activity.nothing-today' | translate }}</ng-container>
        <ng-container *ngIf="!loading && !offlineError && !noDataError">
            <ion-grid>
                <ion-row>
                    <ion-col>
                        <strong>{{ 'dashboard.status.activity.summary-section' | translate }}</strong>
                    </ion-col>
                </ion-row>

                <ion-row>
                    <ion-col>
                        <div class="stat-count">
                            <div class="stat-count-number">
                                {{ todaysOverallJobCount }}
                            </div>
                            <div class="stat-count-title">{{ 'dashboard.status.activity.number-of-new-datasets-suffix' | translate }}</div>
                        </div>
                    </ion-col>
                    <ion-col class="stat-count-change-wrap">
                        <div class="stat-count-change">
                            <div class="stat-count-change-number" *ngIf="changeFactor === 0; else dataChanged">
                                {{ 'dashboard.status.activity.nothing-changed-in-comparison-yesterday' | translate }}
                            </div>
                            <ng-template #dataChanged>
                                <ng-container *ngIf="changeFactorDirection === 'positive'">
                                    <div class="stat-count-change-number change-positive">
                                        {{ 'dashboard.status.activity.percentage-more-than' | translate: { value: changeFactor } }}
                                    </div>
                                    <div class="stat-count-change-title">
                                        {{
                                            'dashboard.status.activity.count-than-yesterday'
                                                | translate: { value: yesterdaysOverallJobCount }
                                        }}
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="changeFactorDirection === 'negative'">
                                    <div class="stat-count-change-number change-negative">
                                        {{ 'dashboard.status.activity.percentage-less-than' | translate: { value: changeFactor } }}
                                    </div>
                                    <div class="stat-count-change-title">
                                        {{
                                            'dashboard.status.activity.count-than-yesterday'
                                                | translate: { value: yesterdaysOverallJobCount }
                                        }}
                                    </div>
                                </ng-container>
                            </ng-template>
                        </div>
                    </ion-col>
                </ion-row>

                <ng-container *ngFor="let projectJobCount of todaysProjectJobCount">
                    <ion-row class="divide-top">
                        <ion-col>
                            <strong>{{ projectJobCount.projectName }}</strong>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <div class="stat-count">
                                <div class="stat-count-number">
                                    {{ projectJobCount.count }}
                                </div>
                                <div class="stat-count-title">
                                    {{ 'dashboard.status.activity.number-of-new-datasets-suffix' | translate }}
                                </div>
                            </div>
                        </ion-col>
                        <ion-col class="stat-count-workers-wrap">
                            <div class="stat-count-workers">
                                {{ projectJobCount.projectWorkers }}
                            </div>
                        </ion-col>
                    </ion-row>
                </ng-container>

                <ion-row *ngIf="updateTimestamp > 0">
                    <ion-col>
                        <div class="activity-footer ion-text-right dp-mt-s">
                            <small
                                ><i>{{
                                    'dashboard.status.activity.last-update' | translate: { date: updateTimestamp | date: 'HH:mm' }
                                }}</i></small
                            >
                        </div>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ng-container>
    </ion-card-content>
</ion-card>
